import { api } from "./api";

export interface photoOrderType {
  photoId: number;
  listOrder: number;
}

export const putPhotoOrderByList = async (photoList: photoOrderType[]) => {
  try {
    const body = photoList;
    const { data } = await api().put("/photo/listOrder/list", body);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const deletePhoto = async (id: number) => {
  try {
    const { data } = await api().delete(`/photo/${id}`);
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const deletePhotoList = async (photoIds: number[]) => {
  try {
    const { data } = await api().delete("/photo/list", { data: photoIds });
    return data;
  } catch (e) {
    console.log(e);
  }
};